import { __read, __awaiter, __generator } from 'tslib';
import React__default from 'react';
import pick from 'lodash/pick';
import { wait } from '../../wait.esm.js';
import { ANIMATED_STYLE_PROPERTIES, COLLAPSED_STYLE, prepareTransition } from './useCollapsible.utils.esm.js';

var useCollapsible = function (duration) {
    if (duration === void 0) { duration = 200; }
    var ref = React__default.useRef(null);
    var initialStyle = React__default.useRef({});
    var _a = __read(React__default.useState(false), 2), isOpen = _a[0], setIsOpen = _a[1];
    var setRef = React__default.useCallback(function (element) {
        if (!element || ref.current)
            return;
        var computedStyle = window.getComputedStyle(element);
        var scrollHeight = element.scrollHeight;
        initialStyle.current = pick(computedStyle, ANIMATED_STYLE_PROPERTIES);
        initialStyle.current.maxHeight = "".concat(scrollHeight, "px");
        Object.assign(element.style, COLLAPSED_STYLE);
        ref.current = element;
    }, [ref]);
    var toggle = React__default.useCallback(function (shouldOpen) {
        if (shouldOpen === void 0) { shouldOpen = !isOpen; }
        return __awaiter(void 0, void 0, void 0, function () {
            var current, scrollHeight, style;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        current = ref.current;
                        if (!current || shouldOpen === isOpen)
                            return [2 /*return*/];
                        scrollHeight = current.scrollHeight, style = current.style;
                        prepareTransition(style, duration);
                        if (!shouldOpen) return [3 /*break*/, 1];
                        // We want to reset max-height to "unset" because when element is opened
                        // its' height might later change based on child elements resizing.
                        current.ontransitionend = function () { return (style.maxHeight = 'unset'); };
                        Object.assign(style, initialStyle.current);
                        setIsOpen(true);
                        return [3 /*break*/, 3];
                    case 1:
                        current.ontransitionend = null;
                        // Before applying "collapsed" style with max-height: 0px we need to
                        // set max-height to some fixed value so transition has a starting point.
                        // Waiting for 20ms is needed so Firefox browser has enough time to apply
                        // fixed max-height to the element before animating.
                        style.maxHeight = "".concat(scrollHeight, "px");
                        return [4 /*yield*/, wait(20)];
                    case 2:
                        _a.sent();
                        Object.assign(style, COLLAPSED_STYLE);
                        setIsOpen(false);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }, [duration, isOpen, ref]);
    return { isOpen: isOpen, setRef: setRef, toggle: toggle };
};

export { useCollapsible as default };
//# sourceMappingURL=useCollapsible.esm.js.map
